import { render, staticRenderFns } from "./CommentsFilterForm.vue?vue&type=template&id=0c4eab7a&"
import script from "./CommentsFilterForm.vue?vue&type=script&lang=js&"
export * from "./CommentsFilterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports